export default __webpack_public_path__ + "static/media/new_booking_illustration.03bb82c9.png";